import { Metric, WorkdayPoint } from './BiEvolucaoMensal'

export function computeDayTypeSlopes(
  pastPoints: WorkdayPoint[],
  metric: Metric
): { workdaySlope: number; nonWorkdaySlope: number } {
  const workdayIncrements: number[] = []
  const nonWorkdayIncrements: number[] = []

  for (let i = 0; i < pastPoints.length; i++) {
    const prevValue = i === 0 ? 0 : pastPoints[i - 1][metric]
    const increment = pastPoints[i][metric] - prevValue
    if (pastPoints[i].isWorkday) {
      workdayIncrements.push(increment)
    } else {
      nonWorkdayIncrements.push(increment)
    }
  }

  const mean = (arr: number[]) =>
    arr.length > 0 ? arr.reduce((a, b) => a + b, 0) / arr.length : 0

  return { workdaySlope: mean(workdayIncrements), nonWorkdaySlope: mean(nonWorkdayIncrements) }
}

export function buildPiecewiseTrendMap(
  lastPastPoint: WorkdayPoint,
  fromTodayPoints: WorkdayPoint[],
  pastPoints: WorkdayPoint[],
  metric: Metric
): Map<number, number> | null {
  if (fromTodayPoints.length === 0) return null

  const { workdaySlope, nonWorkdaySlope } = computeDayTypeSlopes(pastPoints, metric)
  const map = new Map<number, number>()
  map.set(lastPastPoint.workdayIndex, lastPastPoint[metric])

  let runningValue = lastPastPoint[metric]
  for (const point of fromTodayPoints) {
    runningValue += point.isWorkday ? workdaySlope : nonWorkdaySlope
    map.set(point.workdayIndex, runningValue)
  }

  return map
}

export function projetarFechamentoDoMes(
  pontos: WorkdayPoint[],
  metric: Metric
): { realizado: number; projetado: number } {
  const hoje = new Date().toLocaleDateString('en-CA')
  const pontosRealizados = pontos.filter((ponto) => ponto.date <= hoje)
  const realizado = pontosRealizados[pontosRealizados.length - 1]?.[metric] ?? 0
  const pontosPassados = pontos.filter((ponto) => ponto.date < hoje)
  const ultimoPontoPassado = pontosPassados[pontosPassados.length - 1]

  if (!ultimoPontoPassado) return { realizado, projetado: realizado }

  const projecao = buildPiecewiseTrendMap(
    ultimoPontoPassado,
    pontos.filter((ponto) => ponto.date >= hoje),
    pontosPassados,
    metric
  )
  const valoresProjetados = projecao ? Array.from(projecao.values()) : []
  const projetado = valoresProjetados[valoresProjetados.length - 1] ?? realizado

  return { realizado, projetado }
}
